import { useContext, useEffect, useState } from 'react';
import { ModelContext } from './ModelContext';
import restApi from 'api/RestApi';
import loadingIndicator from './loadingIndicator';
import ErrorView from './ErrorView';

export function ModelProvider({ children }) {
    const [model, setModel] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (window.location.href.includes('representation')) {
            restApi
                .getRepresentationModel()
                .then((model) => {
                    setModel(model);
                })
                .catch((err) => {
                    console.error(err);
                    setError(true);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            restApi
                .getLoginModel()
                .then((model) => {
                    setModel(model);
                })
                .catch((err) => {
                    console.error(err);
                    setError(true);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, []);

    useEffect(() => {
        loadingIndicator.set(loading, false);
    }, [loading]);

    if (error) return <ErrorView />;
    if (loading) return null;
    return <ModelContext.Provider value={{ model, loading }}>{children}</ModelContext.Provider>;
}

export function useModel() {
    const ctx = useContext(ModelContext);
    if (!ctx) {
        throw new Error('useModel must be used under ModelProvider');
    }
    return ctx;
}
